module.exports = __webpack_public_path__ + "static/media/jisung-8.jpeg";